import { SceneState } from '../../../components/SceneStatemachinePlugin';
import { BtnRoundelFramed } from '../../../display/BtnRoundelFramed';
import { STRETCHING_ANIMALS, VO_MAP } from '../config/Config';

export class StatePlayfulStretchingSelect extends SceneState {
  startState() {
    this._selectButtons = [];
    this._selectionMade = false;
    this.spawnSelectButton(0);
  }

  spawnSelectButton(index) {
    const animal = STRETCHING_ANIMALS[index];
    if (animal) {
      const x = 600 + index * 320;
      const y = index % 2 == 1 ? 350 : 400;
      const btn = new BtnRoundelFramed(this.scene, x, y, {
        thumbSheet: 'playful_stretching',
        thumbKey: `animal_${animal}`,
        active: true,
        hoverVO: VO_MAP[`select_${animal}`][0],
      });
      btn.id = animal;
      btn.setScale(0);
      this.scene.tweens.add({
        targets: btn,
        scale: 1,
        duration: 200,
        ease: Phaser.Math.Easing.Back.Out,
      });
      this._selectButtons.push(btn);
      this.spawnSelectButton(index + 1);
    } else
      this.scene.game.vo.playChain(VO_MAP.intro, {
        onComplete: this.enableButtons,
        onCompleteScope: this,
      });
  }

  enableButtons() {
    this._selectButtons.filter((b) => {
      b.enable();
      b.once('click', () => this.handleUserSelection(b.id), this);
    });
    this.timer = this.scene.time.addEvent({
      delay: 10000,
      callback: () => {
        this.game.trackPromptStart();
        this.scene.game.vo.playChain(VO_MAP.select_prompt);
      },
      callbackScope: this,
      loop: true,
    });
  }

  handleUserSelection(animal) {
    this.game.trackPromptStop();
    this.timer.remove();
    this.timer = null;
    const selectedbtn = this._selectButtons.find((b) => b.id === animal);
    const nonselectedBtns = this._selectButtons.filter((b) => {
      b.disable();
      return b.id !== animal;
    });
    this.scene.game.soundController.playSFX('sfx', 'choice-bubble');
    this._selectionMade = animal;
    this.scene.tweens.add({
      targets: nonselectedBtns,
      scale: 0,
      duration: 100,
    });
    selectedbtn.once('vocomplete', () => this.endSelection(), this);
  }

  endSelection(btn) {
    this.scene.tweens.add({
      targets: this._selectButtons.find((b) => b.id === this._selectionMade),
      scale: 0,
      duration: 100,
      completeDelay: 100,
      onComplete: () => this.emit('selected', this._selectionMade),
    });
  }

  onScenePaused() {}
  onSceneResumed() {}
  onSceneUpdate(time, delta) {}
  endState() {
    this.scene.game.vo.off('vocomplete', this.endSelection, this);
    if (this.game) {
      this.game?.trackPromptStop();
    }
    if (this.timer) {
      this.timer.remove();
      this.timer = null;
    }

    if (this._selectButtons) {
      this._selectButtons.forEach((b) => b.destroy());
      this._selectButtons = null;
    }
  }
}
